import { render, staticRenderFns } from "./EliminarGeocerca.vue?vue&type=template&id=61892dc0&scoped=true"
import script from "./EliminarGeocerca.vue?vue&type=script&setup=true&lang=js"
export * from "./EliminarGeocerca.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EliminarGeocerca.vue?vue&type=style&index=0&id=61892dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61892dc0",
  null
  
)

export default component.exports